import { useParams, Navigate } from "react-router-dom";
import { Hub } from "@/components/crm/Hub";
import { useAuth } from "@/context/AuthContext";
import Sales from "@/pages/Sales";
import Pitch from "@/pages/Pitch";
import Projects from "@/pages/Projects";
import ProjectOverview from "@/pages/ProjectOverview";
import ProjectPoc from "@/pages/ProjectPoc";
import Production from "@/pages/Production";
import WorkPipeline from "@/pages/WorkPipeline";
import ArtistWork from "@/pages/ArtistWork";
import VendorExpenses from "@/pages/VendorExpenses";
import InternalExpenses from "@/pages/InternalExpenses";
import Invoices from "@/pages/Invoices";
import PurchaseOrders from "@/pages/PurchaseOrders";
import Vendors from "@/pages/Vendors";
import ProjectFinance from "@/pages/ProjectFinance";
import Budget from "@/pages/Budget";
import ExpenseReports from "@/pages/ExpenseReports";
import FinanceSheet from "@/pages/FinanceSheet";
import Overheads from "@/pages/Overheads";
import Employees from "@/pages/Employees";
import HR from "@/pages/HR";
import TeamHub from "@/pages/TeamHub";
import Roles from "@/pages/Roles";
import { ProjectFiles } from "@/components/crm/hub/ProjectFiles";
import { Announcements } from "@/components/crm/hub/Announcements";
import { AccessSummary } from "@/components/crm/hub/AccessSummary";
import { ProjectReport } from "@/components/crm/reports/ProjectReport";
import { WorkloadReport } from "@/components/crm/reports/WorkloadReport";
import { SalesReport } from "@/components/crm/reports/SalesReport";

const HUBS = {
  reports: ["Reports", [{ key: "projects", label: "Project report", perm: "Projects", element: <ProjectReport /> }, { key: "workload", label: "Workload report", perm: "Assignments", element: <WorkloadReport /> },
    { key: "sales", label: "Sales report", perm: "Sales", element: <SalesReport /> }]],
  sales: ["Sales & Pitch", [{ key: "leads", label: "Leads & Quotes", perm: "Sales", element: <Sales /> }, { key: "pitch", label: "New Pitch & Briefs", perm: "Pitch", element: <Pitch /> }]],
  projects: ["Projects", [{ key: "list", label: "New & all projects", perm: "Projects", element: <Projects /> }, { key: "overview", label: "Project overview", perm: "Overview", element: <ProjectOverview /> },
    { key: "poc", label: "POC & team", perm: "POC", element: <ProjectPoc /> }, { key: "production", label: "Production planning", perm: "Production", element: <Production /> },
    { key: "files", label: "Project & work files", perm: "Projects", element: <ProjectFiles /> }]],
  work: ["Work, Artists & HOD", [{ key: "artists", label: "Artist work & HOD approval", perm: "Assignments", element: <ArtistWork /> },
    { key: "pipeline", label: "Department work pipeline", keys: ["Assignments", "Tracker", "Approvals"], element: <WorkPipeline /> }]],
  finance: ["Finance", [{ key: "vendor", label: "Vendor expenses", perm: "VendorExpenses", element: <VendorExpenses /> }, { key: "internal", label: "Internal expenses", perm: "InternalExpenses", element: <InternalExpenses /> },
    { key: "invoices", label: "Client invoices & dues", perm: "Invoices", element: <Invoices /> }, { key: "pos", label: "Purchase orders", perm: "Procurement", element: <PurchaseOrders /> },
    { key: "vendors", label: "Vendors", perm: "Vendors", element: <Vendors /> }]],
  "project-finance": ["Project Finance & P&L", [{ key: "dashboard", label: "Finance dashboard", perm: "Budget", gate: true, element: <ProjectFinance /> },
    { key: "budget", label: "Budget, costing & P&L", perm: "Budget", gate: true, element: <Budget /> }, { key: "reports", label: "Expense reports", perm: "ExpenseReports", gate: true, element: <ExpenseReports /> },
    { key: "sheet", label: "Studio finance sheet", perm: "Budget", gate: true, element: <FinanceSheet /> }, { key: "overheads", label: "Studio overheads", perm: "Budget", gate: true, element: <Overheads /> }]],
  people: ["People & HR", [{ key: "employees", label: "Artists & employees", perm: "Team", element: <Employees /> }, { key: "announcements", label: "HR announcements", perm: "Dashboard", element: <Announcements manage /> },
    { key: "hr", label: "HR & attendance", perm: "HR", element: <HR /> }, { key: "team", label: "Team & communication", perm: "Team", element: <TeamHub /> }]],
  access: ["Roles & Access", [{ key: "summary", label: "Access summary", perm: "Roles", element: <AccessSummary /> }, { key: "roles", label: "Roles, permissions & team logins", perm: "Roles", element: <Roles /> }]],
};

export default function HubPage() {
  const { hub } = useParams();
  const cfg = HUBS[hub];
  const { can } = useAuth();
  if (!cfg || (hub === "finance" && !can("FinanceTeam"))) return <Navigate to="/" replace />;
  return <Hub key={hub} base={`/s/${hub}`} title={cfg[0]} tabs={cfg[1]} />;
}
